import { getLeadStatusFromValue } from "shared/topchef.types";
import { useTranslation } from "react-i18next";

const StatusRenderer = ({ status }: { status: string }) => {
  const { t } = useTranslation();

  const currentLeadStatus = getLeadStatusFromValue(status);
  const translatedStatusLabel = String(t(currentLeadStatus.label));
  return (
    <span className={"brief-state rounded py-1 px-2 m-2 fw-bold "+ currentLeadStatus.css} title={translatedStatusLabel}>{translatedStatusLabel} </span>
  );

};

export default StatusRenderer;
